import { render, staticRenderFns } from "./SelectCoeff.vue?vue&type=template&id=97b03bac&scoped=true"
import script from "./SelectCoeff.vue?vue&type=script&lang=js"
export * from "./SelectCoeff.vue?vue&type=script&lang=js"
import style0 from "./SelectCoeff.vue?vue&type=style&index=0&id=97b03bac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b03bac",
  null
  
)

export default component.exports